import React, { useContext, useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import { NavLink } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import ToggleSwitch from '../../Components/ToggleSwitch';
import { currentDateAndTime } from '../../Constants/constants';
import axios from 'axios';
import Swal from "sweetalert2";
import AttendanceMusterReport from '../Attendences/AttendanceMusterReport';
import { decodeData } from '../../Constants/constants';
import { useLocation } from 'react-router-dom';
import { SubmitButton } from '../../Components/InputElements';

const LockAttendanceAndLeave = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions,setPermissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    
    const [loadingList, setLoadingList] = useState(false);
    const [postLoading, setPostLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [toggleButton, setToggleButton] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);

    const [formData, setFormData] = useState({
        lockAttendanceAndLeave: 0,
    });

    const getList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetPayrollGeneralSetting`, { headers }).then((response) => {
            const { payroll_general_setting, success } = response.data;
            // console.log('GetPayrollSettingInfo ~ response', payroll_general_setting);
            if (success === true) {
                setFormData({
                    lockAttendanceAndLeave: payroll_general_setting[0]?.is_attendance_and_leave_locked
                })
            }
        });
    }

    useEffect(() => {
        getList();
    }, []);

    const handleToggleSwitch = () => {
        setFormData((prevData) => ({
            ...prevData,
            lockAttendanceAndLeave: formData?.lockAttendanceAndLeave === 1 || formData?.lockAttendanceAndLeave === "1" ? 0 : 1,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setPostLoading(true);
        let data = {
            date: currentDateAndTime(),
            isLocked: formData?.lockAttendanceAndLeave == 1 ? "1" : "0",
        }
        const headers = apiHeaderJSON;
        console.log(data);
        axios
            .post(`${apiURL}Payrolls/LockAttendanceAndLeave`, data, {
                headers,
            })
            .then((response) => {
                const { success } = response.data;
                console.log("handleSbmit ~ response =======>>>", response);
                if (success === true) {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true,
                        allowOutsideClick: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        }
                    });

                } else {
                    Swal.fire({
                        title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                        text: response.data.message,
                        icon: success ? 'success' : 'error',
                        showConfirmButton: true,
                        allowOutsideClick: true,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        }
                    });
                }
                setPostLoading(false);
            }).catch((e) => {
                console.log(e);
                setPostLoading(false);
            });
    }
    const handleLeaves = (e) => {
        e.preventDefault();
        const data = {
            date: currentDateAndTime(),
        }
        const headers = apiHeaderJSON;
        console.log(data);
    Swal.fire({
        title: 'Are you sure?',
        text: "You want to run leave accrual!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No!',
    }).then((result) => {
        if (result.isConfirmed) {
        setLoading(true);
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        axios
        .post(`${apiURL}Payrolls/ManualLeaveAccrualAfterPayroll`, data, {
            headers,
        })
        .then((response) => {
            const { success } = response.data;
            console.log("handleSbmit ~ response =======>>>", response);
            Swal.close();
            if (success === true) {
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true, 
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
            } else {
                Swal.fire({
                    title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: success ? 'success' : 'error',
                    showConfirmButton: true, 
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                    }
                });
            }
            setLoading(false);
        }).catch((e) => {
            Swal.close();
            console.log(e);
            setLoading(false);

        });
    }})

    }

    return (
        <div>
            {!loadingList ? (
                <div class="main-content">
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Lock Attendance And Leave`} primary={`Home`} />
                            <div className="card">
                                <div className="card-body">
                                    <div className="row gy-4">
                                        <div className="">
                                            {decodedData?.includes(3) && (
                                                <div className="col-md-12 settings-section">
                                                    <form onSubmit={(e) => handleSubmit(e)} className="row settings-form">
                                                        <div className="col-md-6 settings-section">
                                                            <div>
                                                                <label>Do you want to lock attendance and leave?</label>
                                                            </div>
                                                            <div className="">
                                                                <div className=' d-flex align-items-center gap-2'>
                                                                    <ToggleSwitch isActive={formData?.lockAttendanceAndLeave === 1 || formData?.lockAttendanceAndLeave === "1"} isExtFunc={true} onToggle={handleToggleSwitch} />
                                                                    {/* <span style={{ fontSize:"1.1rem", fontWeight:"600"}} className=' pb-2'>{formData?.lockAttendanceAndLeave === 1 || formData?.lockAttendanceAndLeave === "1"? "On":"Off"}</span> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6 settings-section">
                                                            <div>
                                                                <label>Run Leave accrual after payroll</label>
                                                            </div>
                                                            <div className="">
                                                                <div className=' d-flex align-items-center gap-2'>
                                                                <SubmitButton onClick={(e)=>{ handleLeaves(e) }} loading={loading}
                                                                loadingMessage='Processing' buttonName={'Accrue Leave'} icon={'ri-book-read-line'}
                                                                type='success' iconSide='left' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style={{ width: "60%", margin: "auto" }}>
                                                            {successMsg ?
                                                                <div className=" position-relative alert alert-success mt-3" role="alert">
                                                                    {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                                </div>
                                                                : null
                                                            }
                                                            {/* error message */}
                                                            {errorMsg ?
                                                                <div className=" position-relative alert alert-danger mt-3" role="alert">
                                                                    {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                                                </div> : null
                                                            }
                                                        </div>
                                                        <div style={{ marginTop: "10px", marginBottom: "10px", marginLeft: "Auto" }}>
                                                            {!postLoading ?
                                                                <button
                                                                    type="submit"
                                                                    disabled={loading}
                                                                    className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                                                >
                                                                    <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />
                                                                    {"Save"}
                                                                </button> :
                                                                <button
                                                                    disabled
                                                                    className={`btn btn-primary btn-label waves-effect right waves-light float-right`}
                                                                >
                                                                    <i className={`ri-save-line label-icon align-middle fs-16 ms-2`} />
                                                                    {"Loading..."}
                                                                </button>
                                                            }

                                                        </div>
                                                    </form>
                                                </div>
                                            )}
                                            {/* <div style={{ backgroundColor: "#F3F3F9", borderRadius: "5px" }} className="mt-1 settings-section">
                                                <h4 style={{ fontSize: "1rem" }} className="card-title mt-4 px-3 pt-2">
                                                    Attendance Muster Report
                                                </h4>
                                                <AttendanceMusterReport />
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "90vh" }}
                >
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default LockAttendanceAndLeave;
